export var RegistrationChannel;
(function (RegistrationChannel) {
    RegistrationChannel[RegistrationChannel["Unknown"] = 1] = "Unknown";
    RegistrationChannel[RegistrationChannel["LoginPage"] = 2] = "LoginPage";
    RegistrationChannel[RegistrationChannel["RegisterToken"] = 3] = "RegisterToken";
    RegistrationChannel[RegistrationChannel["QRCode"] = 4] = "QRCode";
})(RegistrationChannel || (RegistrationChannel = {}));



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/validation/validationModels.ts